<div class="form-ui" [ngClass]="{'container': (isSmallScreen | async)}">
    <mat-card>
        <mat-card-title>New prescription</mat-card-title>
        <mat-stepper linear #stepper [orientation]="(stepperOrientation | async)!">
            <mat-step [stepControl]="customerDetailsForm" [editable]="isEditable">
                <ng-template matStepLabel>Fill out your details</ng-template>
                <form autocomplete="off" [formGroup]="customerDetailsForm" class="mt-2">
                    <div class="row">
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Title</mat-label>
                                    <mat-select data-testid="customer-title" formControlName="title">
                                        <mat-option value="Mr">Mr</mat-option>
                                        <mat-option value="Mrs">Mrs</mat-option>
                                        <mat-option value="Miss">Miss</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="customerDetailsForm.get('title')?.invalid">
                                        Title is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Your Initials</mat-label>
                                    <input data-testid="customer-initials" formControlName="initials" matInput placeholder="Initials">
                                    <mat-error *ngIf="customerDetailsForm.get('initials')?.invalid">
                                        Initials are required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Your First Name</mat-label>
                                    <input data-testid="customer-first-name" formControlName="firstName" matInput placeholder="First name">
                                    <mat-error *ngIf="customerDetailsForm.get('firstName')?.invalid">
                                        First Name is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Your Last Name</mat-label>
                                    <input data-testid="customer-last-name" formControlName="lastName" matInput placeholder="Last Name">
                                    <mat-error *ngIf="customerDetailsForm.get('lastName')?.invalid">
                                        Last Name is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Your Gender</mat-label>
                                    <mat-select data-testid="customer-gender" formControlName="gender">
                                        <mat-option value="male">Male</mat-option>
                                        <mat-option value="female">Female</mat-option>
                                        <mat-option value="other">Other</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="customerDetailsForm.get('gender')?.invalid">
                                        Gender is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Date of birth</mat-label>
                                    <input data-testid="customer-date-of-birth" formControlName="dateOfBirth" matInput [matDatepicker]="picker">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-error *ngIf="customerDetailsForm.get('date')?.invalid">
                                        Date of birth is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                        <div class="col-md-6">
                            
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input data-testid="customer-email" formControlName="email" type="email" matInput placeholder="Email address">
                                    <mat-error *ngIf="customerDetailsForm.get('email')?.invalid">
                                        Email is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Alternative email</mat-label>
                                    <input data-testid="customer-alt-email" formControlName="emailAlt" type="email" matInput placeholder="Email address">
                                    <mat-error *ngIf="customerDetailsForm.get('emailAlt')?.invalid">
                                        Alternative email is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Your Phone Number</mat-label>
                                    <input data-testid="customer-phone-number" formControlName="phoneNumber" matInput placeholder="Phone Number">
                                    <mat-error *ngIf="customerDetailsForm.get('phoneNumber')?.invalid">
                                        Phone number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Alternative Phone Number</mat-label>
                                    <input data-testid="customer-alternative-phone-number" formControlName="alternativeNumber" matInput placeholder="Phone Number">
                                    <mat-error *ngIf="customerDetailsForm.get('alternativeNumber')?.invalid">
                                        Phone Number is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Who is this prescription for?</mat-label>
                                    <mat-select data-testid="customer-for-who" formControlName="forWho">
                                        <mat-option *ngFor="let option of forWhoOptions" [value]="option">
                                            {{option}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="customerDetailsForm.get('forWho')?.invalid">
                                        Select who is this for
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                    </div>
                    <div class="text-end">
                        <button data-testid="next-step" [disabled]="!customerDetailsForm.valid" class='mx-1' color="primary" mat-raised-button
                            matStepperNext>
                            <mat-icon>chevron_right</mat-icon> Next
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step
                *ngIf="(customerDetailsForm.value.forWho===ForWho.Me || customerDetailsForm.value.forWho===ForWho.Company)"
                [stepControl]="selfForm" [editable]="isEditable">
                <ng-template matStepLabel>Prescription details</ng-template>
                <form autocomplete="off" class='mt-1' [formGroup]="selfForm">
                    <div class="row">
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Number Of Dependants</mat-label>
                                    <input data-testid="self-number-of-dependants" type="number" min="1" formControlName="numberOfDependants" matInput
                                        placeholder="Number of Dependants">
                                    <mat-error *ngIf="selfForm.get('numberOfDependants')?.invalid">
                                        Number of dependants is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Search for a country</mat-label>
                                    <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name">
                                            {{country.name}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon matPrefix>search</mat-icon>
                                    <mat-error *ngIf="selfForm.get('country')?.invalid">
                                        Country is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Province</mat-label>
                                    <mat-select data-testid="self-province" formControlName="province">
                                        <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                            {{province.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="selfForm.get('province')?.invalid">
                                        Province is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address Line 1</mat-label>
                                    <input data-testid="self-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                                    <mat-error *ngIf="selfForm.get('addressLine1')?.invalid">
                                        Address Line 1 is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            
                        </div>
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address Line 2</mat-label>
                                    <input data-testid="self-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                                    <mat-error *ngIf="selfForm.get('addressLine2')?.invalid">
                                        Address Line 2 is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Building Number</mat-label>
                                    <input data-testid="self-building-apt-number" type="number" min="1" formControlName="buildingAptNumber" matInput
                                        placeholder="Building Number">
                                    <mat-error *ngIf="selfForm.get('buildingAptNumber')?.invalid">
                                        Building number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Postcode</mat-label>
                                    <input data-testid="self-postcode" formControlName="postcode" matInput placeholder="Postcode">
                                    <mat-error *ngIf="selfForm.get('postcode')?.invalid">
                                        Postcode is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Select method of delivery</mat-label>
                                    <mat-select data-testid="self-delivery-type" #chosenValue formControlName="deliveryType">
                                        <mat-option *ngFor="let type of deliveryTypes" value="{{type.id}}">
                                            {{type.type}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="selfForm.get('deliveryType')?.invalid">
                                        Method of delivery is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                    </div>
                    <div class="text-end">
                        <button data-testid="previous-step" class="mx-1" color="primary" mat-raised-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Back
                        </button>
                        <button data-testid="next-step" *ngIf="customerDetailsForm.value.forWho===ForWho.Company" [disabled]="!selfForm.valid"
                            class="mx-1" color="primary" mat-raised-button matStepperNext>
                            <mat-icon>chevron_right</mat-icon> Next
                        </button>
                        <button data-testid="save-button" *ngIf="customerDetailsForm.value.forWho===ForWho.Me" [disabled]="!selfForm.valid"
                            class="mx-1" color="primary" mat-raised-button (click)="submitPrescription()">
                            <mat-icon>save</mat-icon> Save
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step *ngIf="customerDetailsForm.value.forWho===ForWho.Company" [editable]="isEditable">
                <ng-template matStepLabel>Company details</ng-template>
                <form autocomplete="off" [formGroup]="companyPrescriptionDetailsForm">
                    <div class="row">
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Company name</mat-label>
                                    <input data-testid="company-name" formControlName="companyName" matInput placeholder="Company name">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('companyName')?.invalid">
                                        Company name is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Email address</mat-label>
                                    <input data-testid="company-email" formControlName="email" matInput placeholder="Email address">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('email')?.invalid">
                                        Email address is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Alternative email address</mat-label>
                                    <input data-testid="company-email-alt" formControlName="emailAlt" matInput placeholder="Email address">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('emailAlt')?.invalid">
                                        Alternative email address is not valid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Phone number</mat-label>
                                    <input data-testid="company-phone-number" formControlName="phoneNumber" matInput placeholder="Phone number">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('phoneNumber')?.invalid">
                                        Phone number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Alternative phone number</mat-label>
                                    <input data-testid="company-alternative-phone-number" formControlName="phoneNumberAlt" matInput
                                        placeholder="Alternative phone number">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('phoneNumberAlt')?.invalid">
                                        Alternative phone number is not valid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Practice number</mat-label>
                                    <input data-testid="company-practice-number" formControlName="practiceNumber" matInput placeholder="Practice number">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('practiceNumber')?.invalid">
                                        Practice number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>VAT registration number</mat-label>
                                    <input data-testid="company-vat-reg-number" formControlName="vatRegistrationNumber" matInput
                                        placeholder="VAT registration number">
                                    <mat-error
                                        *ngIf="companyPrescriptionDetailsForm.get('vatRegistrationNumber')?.invalid">
                                        VAT registration number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Company type</mat-label>
                                    <mat-select data-testid="company-type" formControlName="companyType">
                                        <mat-option *ngFor="let type of companyTypes" [value]="type.id">
                                            {{type.type}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('companyType')?.invalid">
                                        Select company type
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Search for a country</mat-label>
                                    <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let country of filteredCountriesForCompany  | async" [value]="country.name">
                                            {{country.name}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon matPrefix>search</mat-icon>
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('country')?.invalid">
                                        Country is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Province</mat-label>
                                    <mat-select data-testid="company-province" formControlName="province">
                                        <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                            {{province.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('province')?.invalid">
                                        Province is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address line 1</mat-label>
                                    <input data-testid="company-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('addressLine1')?.invalid">
                                        Address Line 1 is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address line 2</mat-label>
                                    <input data-testid="company-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('addressLine2')?.invalid">
                                        Address Line 2 is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Building Number</mat-label>
                                    <input data-testid="company-building-apt-number" formControlName="buildingAptNumber" type="number" min="1" matInput
                                        placeholder="Building Number">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('buildingAptNumber')?.invalid">
                                        Building Number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Postcode</mat-label>
                                    <input data-testid="company-postcode" formControlName="postcode" matInput placeholder="Postcode">
                                    <mat-error *ngIf="companyPrescriptionDetailsForm.get('postcode')?.invalid">
                                        Postcode is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                        </div>
                    </div>
                    <div class='text-end'>
                        <button class='mx-1' data-testid="previous-step" color="primary" mat-raised-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Back
                        </button>
                        <button data-testid="save-button" [disabled]="!companyPrescriptionDetailsForm.valid" class='mx-1' color="primary"
                            mat-raised-button (click)="submitPrescription()">
                            <mat-icon>save</mat-icon> Save
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step *ngIf="customerDetailsForm.value.forWho===ForWho.SomeOneElse" [editable]="isEditable">
                <ng-template matStepLabel>Prescription details</ng-template>
                <form autocomplete="off"  [formGroup]="individualPrescriptionDetailsForm">
                    <div class="row">
                        <div class="col-md-6">
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Title</mat-label>
                                    <mat-select data-testid="individual-title" formControlName="title">
                                        <mat-option value="Mr">Mr</mat-option>
                                        <mat-option value="Mrs">Mrs</mat-option>
                                        <mat-option value="Miss">Miss</mat-option>
                                        <mat-option value="Prof">Prof</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('title')?.invalid">
                                        Choose from provided options
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Initials</mat-label>
                                    <input data-testid="individual-initials" formControlName="initials" matInput placeholder="Initials">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('initials')?.invalid">
                                        Initials are required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>First Name</mat-label>
                                    <input data-testid="individual-first-name" formControlName="firstName" matInput placeholder="First name">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('firstName')?.invalid">
                                        First Name is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Surname</mat-label>
                                    <input data-testid="individual-last-name" formControlName="lastName" matInput placeholder="Last name">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('lastName')?.invalid">
                                        Surname is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Gender</mat-label>
                                    <mat-select data-testid="individual-gender" formControlName="gender">
                                        <mat-option value="male">Male</mat-option>
                                        <mat-option value="female">Female</mat-option>
                                        <mat-option value="other">Other</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('gender')?.invalid">
                                        Gender is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Is an animal?</mat-label>
                                    <mat-select data-testid="individual-is-animal" formControlName="isAnimal">
                                        <mat-option value="0">No</mat-option>
                                        <mat-option value="1">Yes</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('isAnimal')?.invalid">
                                        Required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Date of birth</mat-label>
                                    <input data-testid="individual-date-of-birth" formControlName="dateOfBirth" matInput [matDatepicker]="picker1">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('date')?.invalid">
                                        Date of birth is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Phone number</mat-label>
                                    <input data-testid="individual-phone-number" formControlName="phoneNumber" matInput placeholder="Phone Number">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('phoneNumber')?.invalid">
                                        Phone number is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label> Alternative phone nnumber</mat-label>
                                    <input data-testid="individual-alt-number" formControlName="phoneNumberAlt" matInput placeholder="Alternative phone number">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('phoneNumberAlt')?.invalid">
                                      Alternative phone number is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label> Email</mat-label>
                                    <input data-testid="individual-email" formControlName="email" type="email" matInput placeholder="Email address">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('email')?.invalid">
                                      Email  is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                        <div class="col-md-6">

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label> Alternative email address</mat-label>
                                    <input data-testid="individual-alt-email" formControlName="emailAlt" type="email" matInput placeholder="Alternative email address">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('emailAlt')?.invalid">
                                      Email  is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Number Of Dependants</mat-label>
                                    <input data-testid="individual-number-of-dependants" type="number" min="1" formControlName="numberOfDependants" matInput
                                        placeholder="Number of Dependants">
                                    <mat-error
                                        *ngIf="individualPrescriptionDetailsForm.get('numberOfDependants')?.invalid">
                                        Number of dependants is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Search for a country</mat-label>
                                    <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let country of filteredCountriesForIndividual  | async" [value]="country.name">
                                            {{country.name}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-icon matPrefix>search</mat-icon>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('country')?.invalid">
                                        Country is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Province</mat-label>
                                    <mat-select data-testid="individual-province" formControlName="province">
                                        <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                            {{province.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('province')?.invalid">
                                        Province is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address line 1</mat-label>
                                    <input data-testid="individual-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('addressLine1')?.invalid">
                                        Address Line 1 is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Address line 2</mat-label>
                                    <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('addressLine2')?.invalid">
                                        Address Line 2 is invalid
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Building Number</mat-label>
                                    <input data-testid="individual-building-apt-number" formControlName="buildingAptNumber" type="number" min="1" matInput placeholder="Building Number">
                                    <mat-error
                                        *ngIf="individualPrescriptionDetailsForm.get('buildingAptNumber')?.invalid">
                                        Building Number is required
                                    </mat-error>
                                </mat-form-field>
                            </p>
                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Postcode</mat-label>
                                    <input data-testid="individual-postcode" formControlName="postcode" matInput placeholder="Postcode">
                                    <mat-error *ngIf="individualPrescriptionDetailsForm.get('postcode')?.invalid">
                                        Postcode is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                            <p>
                                <mat-form-field appearance="outline">
                                    <mat-label>Select method of delivery</mat-label>
                                    <mat-select data-testid="individual-delivery-type" #chosenValue formControlName="deliveryType">
                                        <mat-option *ngFor="let type of deliveryTypes" value="{{type.id}}">
                                            {{type.type}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="selfForm.get('deliveryType')?.invalid">
                                        Method of delivery is required
                                    </mat-error>
                                </mat-form-field>
                            </p>

                        </div>
                    </div>
                    <div class="text-end">
                        <button data-testid="previous-step" class="mx-1" color="primary" mat-raised-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Back
                        </button>
                        <button data-testid="save-button" [disabled]="!individualPrescriptionDetailsForm.valid" class="mx-1" color="primary"
                            mat-raised-button (click)="submitPrescription()">
                            <mat-icon>save</mat-icon> Save
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="uploadPrescriptionForm" [editable]="isEditable">
                <ng-template matStepLabel>Upload file from computer</ng-template>
                <core-file-uploader [accept]="acceptFiles" [uploadButtonText]="'Complete prescription'"
                    (onFileUploaded)="onFileUploaded($event)" [orderId]="orderId"></core-file-uploader>
            </mat-step>
        </mat-stepper>
    </mat-card>
</div>